import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  pt: 0.5,
};
